import React from "react";
import styles from "./SchoolDetailsCard.module.css";

export interface SchoolDetailsCardProps {
  schoolName: string;
  udiseCode: string;
  govtSchoolId: string;
  state: string;
  district: string;
  city: string;
  pincode: string;
  address: string;
  status: "registered" | "new";
}

const SchoolDetailsCard: React.FC<SchoolDetailsCardProps> = ({
  schoolName,
  udiseCode,
  govtSchoolId,
  state,
  district,
  city,
  pincode,
  address,
  status,
}) => {
  return (
    <div className={`${styles.card} ${styles[status]}`}>
      <div className={styles.header}>
        <h3 className={styles.schoolName}>{schoolName}</h3>
        <div className={`${styles.statusBadge} ${styles[`${status}Badge`]}`}>
          <span className={styles.statusText}>
            {status === "registered" ? "Registered" : "New"}
          </span>
        </div>
      </div>

      <div className={styles.content}>
        <div className={styles.row}>
          <div className={styles.field}>
            <span className={styles.label}>UDISE CODE :</span>
            <span className={styles.value}>{udiseCode}</span>
          </div>
          <div className={styles.field}>
            <span className={styles.label}>Govt. school ID:</span>
            <span className={styles.value}>{govtSchoolId}</span>
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.field}>
            <span className={styles.label}>State :</span>
            <span className={styles.value}>{state}</span>
          </div>
          <div className={styles.field}>
            <span className={styles.label}>District :</span>
            <span className={styles.value}>{district}</span>
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.field}>
            <span className={styles.label}>City :</span>
            <span className={styles.value}>{city}</span>
          </div>
          <div className={styles.field}>
            <span className={styles.label}>Pincode :</span>
            <span className={styles.value}>{pincode}</span>
          </div>
        </div>

        <div className={styles.address}>{address}</div>
      </div>
    </div>
  );
};

export default SchoolDetailsCard;
